// extracted by mini-css-extract-plugin
export default {"logo":"Icon_logo__2gejg","buttonImage":"Icon_buttonImage__-2Gbv","noCursorButtonImage":"Icon_noCursorButtonImage__7X3um"};